var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quiz-response"},[_c('single-response-item',{attrs:{"questionId":_vm.questionId}}),_c('div',{staticClass:"cta"},[_c('vv-button',{on:{"click":_vm.nextQuestion}},[_vm._v(_vm._s(_vm.nextLabel))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }